<div class="btn-group btn-block" *ngIf="isWaitingForAccept">
    <button class="btn btn-sm btn-success" (click)="acceptAssignment()">
        {{ 'my-tasks.accept-task' | translate }}
    </button>
    <button class="btn btn-sm btn-danger" (click)="showRejectConfirm()">
        {{ 'my-tasks.reject-task' | translate }}
    </button>
</div>
<button *ngIf="!isWaitingForAccept" [class]="buttonClasses" (click)="onClick()">
    {{ 'my-tasks.' + buttonText | translate }}
</button>

<lib-modal
    [title]="'my-tasks.reject-task-confirm' | translate"
    [componentID]="'reject-task-confirm' + task.deliveryTaskID"
>
    <div class="text-center w-100">
        <button class="btn btn-danger w-75 mb-4" (click)="onRejectConfirmed()">
            {{ 'my-tasks.reject-task' | translate }}
        </button>
        <button class="btn btn-secondary w-75" (click)="hideRejectConfirm()">
            {{ 'common.cancel' | translate }}
        </button>
    </div>
</lib-modal>
